export interface PartnerLogo {
    src: string;
    alt: string;
}

export const PARTNER_LOGOS: PartnerLogo[] = [
    {
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/47d529ca65938ea8768f2a5c30c261ae-1762839525225/Trusted%20by_.svg',
        alt: 'Trusted by',
    },
    {
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/a80c49e9697a70ad322cc6b91dc0bf1c-1762839418896/Meta_Platforms_Inc._logo%201.svg',
        alt: 'Meta',
    },
    {
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/a80c49e9697a70ad322cc6b91dc0bf1c-1762839391029/google_big.svg',
        alt: 'Google',
    },
    {
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/a80c49e9697a70ad322cc6b91dc0bf1c-1762839426418/netflix_big.svg',
        alt: 'Netflix',
    },
    {
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/a80c49e9697a70ad322cc6b91dc0bf1c-1762839429638/P_G.svg',
        alt: 'P&G',
    },
    {
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/a80c49e9697a70ad322cc6b91dc0bf1c-1762839441439/paypal_big.svg',
        alt: 'PayPal',
    },
    {
        src: 'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/a80c49e9697a70ad322cc6b91dc0bf1c-1762839437702/Payoneer_Master_Logo_White_RGB%201.svg',
        alt: 'Payoneer',
    },
];
